import Image from "./image.web"
import ImageEmail from "./image.email"
import CaptionedImage from "./captioned-image.web"
import CaptionedImageEmail from "./captioned-image.email"

export default {
  component: CaptionedImage,
  email: CaptionedImageEmail,
  nodes: {
    image: {
      component: Image,
      email: ImageEmail
    }
  }
}
